import request from '../config/request'



// 获取搜索汇总
export const getOverall = (params) => request('POST', '/get_status_by_search', params)

// 搜索文献
export const handleSearch = (params) => request('GET', '/search', params)

// 获取筛选条件
export const getFilters = () => request('GET', '/filters')

// 翻译重点信息
export const translateInfo = (info) => request('GET', '/translate', info)

// 获取文献详情
export const getDocDetail = (params) => request('GET', '/get_doc_details', params)

// 获取token
export const getToken = (code) => request('POST', '/login', code)

// 获取搜索历史记录
export const getHis = () => request('GET', '/handle_search_his', )

//删除历史记录
export const delHisHandle = (params) => request('DELETE', '/handle_search_his', params)

// 获取用户角色
export const getRole = () => request('GET', '/role')

// 文献基本搜索
export const normalSearch = (params) => request('POST', '/normal', params)

// 查看文献全文
export const fullText = (id) => request('GET', id + '/detail')

// 收藏文献
export const collection = (type, id) => request(type, '/collect/', id)

// 按疾病或药品搜索
export const drugSearch = (params) => request('POST', '/drug', params)

// 精准搜索
export const advancedSearch = (params) => request('POST', '/advanced', params)

// 上下位关键词
export const upDownKey = (params) => request('GET', '/keyword/hierarchy', params)

// 相关关键词
export const relatedKey = (params) => request('GET', '/keyword/concurrence', params)

// 获取历史记录
export const getHistory = (params) => request('GET', '/advanced/search_log/', params)

// 删除历史记录
export const deleteHistory = (params) => request('DELETE', '/advanced/search_log/', params)

// 文献分析
export const analysis = (params, progress) => request('POST', '/analysis', params, progress)

// 获取/删除基本搜索历史记录
export const baseHistory = (types, params) => request(types, '/search_log/', params)

// 获取文献推荐结果
export const getRecommendArticles = (params) => request('GET', '/get_recommend_articles', params)

// 查看原文链接
export const getArticleUrl = (params) => request('GET', '/get_article_url', params)

// 下载ppt
export const downloadPPT = '/download_ppt'

// 下载 word
export const downloadWord = '/download_word'

// 获取vip等级
export const getUserVip = () => request('GET','/get_user_vip')

// 获取病例搜索提示
export const caseSearchSuggest = (params) => request('get', '/get_query_suggest', params)

// 病例搜索
export const caseSearch = (data) => request('post', '/patient_search', data)

// 病例翻译
export const caseTranslate = (data) => request('get', '/get_patient_translation', data)

// 相似病例
export const caseSimilar = (data) => request('post', '/get_relate_patients', data)

// 病例收藏
export const caseCollect = (type, data) => request(type, '/patient_collect', data)

// 获取病例详情页
export const caseDetail = (id) => request('get', id + '/patient_detail')

// 病例下载
export const downLoadCase = '/download_patient'

// 病例总结
export const caseAnalysis = (data, progress) => request('post', '/patient_analysis', data, progress)


// 研究搜索
export const trialSearch = (data) => request("POST",'/clinical_search',data);

// 研究 收藏/ 取消收藏/收藏列表
export const trialCollect = (type, data) => request(type, '/clinical_collect', data)

// 研究详情页
export const trialDetail = (registration) => request('GET',`/${registration}/clinical_detail`);

// 相似研究
export const trialSimilar = (data) => request('POST', '/get_similarly_clinical', data)

// 研究总结
export const trialAnalysis = (data) => request('POST', '/study_analysis', data)

// 研究相关文献
export const trilaRelatedArticle = (data) => request('POST','/get_abstract_by_pmids',data);

// 研究翻译
export const trialTranslate = (data) => request('GET','/translate_trial',data);

// 检查论⽂是否已上传
export const checkArticleData = (params) => request('GET', '/check_paper_data', params)

// 基于论⽂信息⽣成若⼲推荐问题/关键词
export const generateQuesKeywords = (params) => request('POST', '/generate_questions_and_keywords', params)

// 基于论⽂聊天
export const articleConversation = (params) => request('POST', '/conversation', params)

// 基于论⽂聊天记录
export const articleConversationHistory = (params) => request('POST', '/conversation_history', params)

// 获取请求参数
function getUrl(url) {
    if (url.indexOf("?") != -1) {
        var index = url.indexOf('?') + 1;
        var str = url.substring(index, url.length);
        var strs = str.split('&');
        var json = {};
        for (var i = 0; i < strs.length; i++) {
            var str2 = strs[i].split('=');
            json[str2[0]] = str2[1];
        }
        return json
    }
}
export const getParams = getUrl;


// WEBPACK FOOTER //
// ./src/service/getData.js